module.exports = __webpack_public_path__ + "static/media/6.23.22efbd34.png";